import type { RouteObject } from 'react-router';

import * as userDashboardAccountSettingsHorizonRouteExports from '#/modules/userDashboard/pages/AccountSettings/UserDashboardAccountSettings.horizon-route';
import * as userDashboardAddPaymentMethodHorizonRouteExports from '#/modules/userDashboard/pages/AddPaymentMethod/UserDashboardAddPaymentMethodPage.horizon-route';
import * as userDashboardApplicationHistoryHorizonRouteExports from '#/modules/userDashboard/pages/ApplicationHistory/UserDashboardApplicationHistory.horizon-route';
import * as userDashboardApplicationSummaryHorizonRouteExports from '#/modules/userDashboard/pages/ApplicationSummary/UserDashboardApplicationSummary.horizon-route';
import * as userDashboardCreateEventHorizonRouteExports from '#/modules/userDashboard/pages/CreateEvent/UserDashboardCreateEvent.horizon-route';
import * as userDashboardEditEventHorizonRouteExports from '#/modules/userDashboard/pages/EditEvent/UserDashboardEditEvent.horizon-route';
import * as userDashboardEmploymentProfileOnboardingHorizonRouteExports from '#/modules/userDashboard/pages/EmploymentProfileOnboarding/UserDashboardEmploymentProfileOnboarding.horizon-route';
import * as userDashboardManageEventsHorizonRouteExports from '#/modules/userDashboard/pages/ManageEvents/UserDashboardManageEvents.horizon-route';
import * as userDashboardNotFoundHorizonRouteExports from '#/modules/userDashboard/pages/NotFound/UserDashboardNotFound.horizon-route';
import * as userDashboardNotificationPreferencesHorizonRouteExports from '#/modules/userDashboard/pages/NotificationPreferences/UserDashboardNotificationPreferences.horizon-route';
import * as userDashboardPostAListingHorizonRouteExports from '#/modules/userDashboard/pages/PostAListing/UserDashboardPostAListing.horizon-route';
import * as userDashboardPreviewEventHorizonRouteExports from '#/modules/userDashboard/pages/PreviewEvent/UserDashboardPreviewEvent.horizon-route';
import * as userDashboardProfessionalExperienceHorizonRouteExports from '#/modules/userDashboard/pages/ProfessionalExperience/UserDashboardProfessionalExperience.horizon-route';
import * as userDashboardProfileHorizonRouteExports from '#/modules/userDashboard/pages/Profile/UserDashboardProfile.horizon-route';
import * as userDashboardSavedItemsHorizonRouteExports from '#/modules/userDashboard/pages/SavedItems/UserDashboardSavedItems.horizon-route';
import * as userDashboardSelectOrgHorizonRouteExports from '#/modules/userDashboard/pages/SelectOrg/UserDashboardSelectOrg.horizon-route';
import * as userDashboardViewEventHorizonRouteExports from '#/modules/userDashboard/pages/ViewEvent/UserDashboardViewEvent.horizon-route';
import * as userDashboardSubLayoutHorizonRouteExports from '#/modules/userDashboard/sub-layout/UserDashboardSubLayout.horizon-route';
import { postAListingRoute } from '#/routing/routes';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import {
  userDashboardAccountSettingsRoute,
  userDashboardApplicationHistoryRoute,
  userDashboardApplicationSummaryRoute,
  userDashboardCreateEventRoute,
  userDashboardEditEventRoute,
  userDashboardListEventsRoute,
  userDashboardNotificationPreferencesRoute,
  userDashboardPaymentMethodsAddCardRoute,
  userDashboardPreviewEventRoute,
  userDashboardProfessionalExperienceRoute,
  userDashboardProfileRoute,
  userDashboardRouteGroup,
  userDashboardSavedItemsRoute,
  userDashboardSelectOrgRoute,
  userDashboardViewEmploymentOnboardingRoute,
  userDashboardViewEventRoute,
} from './userDashboard.routes';

export const userDashboardRouteObjects = [
  {
    path: userDashboardApplicationSummaryRoute.fullPath,
    ...horizonRouteToObject(userDashboardApplicationSummaryHorizonRouteExports),
  },
  {
    path: postAListingRoute.fullPath,
    ...horizonRouteToObject(userDashboardPostAListingHorizonRouteExports),
  },
  {
    path: userDashboardCreateEventRoute.fullPath,
    ...horizonRouteToObject(userDashboardCreateEventHorizonRouteExports),
  },
  {
    path: userDashboardViewEventRoute.fullPath,
    ...horizonRouteToObject(userDashboardViewEventHorizonRouteExports),
  },
  {
    path: userDashboardPreviewEventRoute.fullPath,
    ...horizonRouteToObject(userDashboardPreviewEventHorizonRouteExports),
  },
  {
    path: userDashboardViewEmploymentOnboardingRoute.fullPath,
    ...horizonRouteToObject(
      userDashboardEmploymentProfileOnboardingHorizonRouteExports,
    ),
  },
  {
    ...horizonRouteToObject(userDashboardSubLayoutHorizonRouteExports),
    children: [
      {
        path: userDashboardSelectOrgRoute.fullPath,
        ...horizonRouteToObject(userDashboardSelectOrgHorizonRouteExports),
      },
      {
        path: userDashboardEditEventRoute.fullPath,
        ...horizonRouteToObject(userDashboardEditEventHorizonRouteExports),
      },
      {
        path: userDashboardListEventsRoute.fullPath,
        ...horizonRouteToObject(userDashboardManageEventsHorizonRouteExports),
      },
      {
        path: userDashboardNotificationPreferencesRoute.fullPath,
        ...horizonRouteToObject(
          userDashboardNotificationPreferencesHorizonRouteExports,
        ),
      },
      {
        path: userDashboardProfileRoute.fullPath,
        ...horizonRouteToObject(userDashboardProfileHorizonRouteExports),
      },
      {
        path: userDashboardProfessionalExperienceRoute.fullPath,
        ...horizonRouteToObject(
          userDashboardProfessionalExperienceHorizonRouteExports,
        ),
      },
      {
        path: userDashboardAccountSettingsRoute.fullPath,
        ...horizonRouteToObject(
          userDashboardAccountSettingsHorizonRouteExports,
        ),
      },
      {
        path: userDashboardPaymentMethodsAddCardRoute.fullPath,
        ...horizonRouteToObject(
          userDashboardAddPaymentMethodHorizonRouteExports,
        ),
      },
      {
        path: userDashboardSavedItemsRoute.fullPath,
        ...horizonRouteToObject(userDashboardSavedItemsHorizonRouteExports),
      },
      {
        path: userDashboardApplicationHistoryRoute.fullPath,
        ...horizonRouteToObject(
          userDashboardApplicationHistoryHorizonRouteExports,
        ),
      },
      {
        path: userDashboardRouteGroup.fullWrapperPath,
        ...horizonRouteToObject(userDashboardNotFoundHorizonRouteExports),
      },
    ],
  },
] satisfies RouteObject[];
